import React from 'react';
import WeatherSearch from './components/WeatherSearch.js';
import './App.css';

function App() {
  return (
    <div>
      <WeatherSearch/>
    </div>
  );
}
export default App;
